import { ApolloError } from '@apollo/client';
import { Box } from '@mui/material';

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Pagination,
  LoadedContent,
  TableContainer,
} from '@occc/ui-design-system';
import { KioskAssetFragment } from '@occc/graphql';
import { IPaginationProps } from '@occc-app/hooks/usePaginatedQuery';

import { AssignAssetTableRow } from './assign-asset-table-row.component';

type AssignAssetTableProps = {
  loading: boolean;
  error?: ApolloError;
  data?: KioskAssetFragment[];
  paginationProps: IPaginationProps;
  selectedAssetId: string | null;
  onAssetSelect: (assetId: string) => void;
};

export const AssignAssetTable = ({
  loading,
  error,
  data,
  paginationProps,
  selectedAssetId,
  onAssetSelect,
}: AssignAssetTableProps) => {
  const renderData = (assets: KioskAssetFragment[]) => (
    <TableContainer sx={{ boxShadow: 'none' }}>
      <Box sx={{ overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Description</TableCell>
              <TableCell sx={{ textAlign: 'right' }}>Image</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {assets.map((asset) => (
              <AssignAssetTableRow
                key={asset.id}
                asset={asset}
                isSelected={selectedAssetId === asset.id}
                onSelect={onAssetSelect}
              />
            ))}
          </TableBody>
        </Table>
      </Box>
      <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
        <Pagination {...paginationProps} />
      </Box>
    </TableContainer>
  );

  return (
    <LoadedContent<KioskAssetFragment>
      error={error}
      loading={loading}
      items={data}
      renderData={renderData}
    />
  );
};
